import React, {Component} from 'react';
import PropTypes from 'prop-types';

import medal from '../../assets/img/medal.svg';

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export default class ScoreDiv extends Component {
  static propTypes = {
    text: PropTypes.string,
  };
  static defaultProps = {
    showMedal: false
  };
  constructor (props) {
    super(props);
    this.state = {
      text: this.props.text,
      showMedal: this.props.showMedal,
    };
  }

  componentWillReceiveProps(state) {
    this.setState({
      ...this.state,
      ...state,
    });
  }

  render() {
    return (
      <div className={'score-div'}>
        {this.state.showMedal ? (
          <img src={medal} alt={'medal'} />
        ) : null}
        {this.state.text ? (
          <span>{numberWithCommas(this.state.text)}</span>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/ScoreDiv.js